<template>
	<div :class="{loadingBox:true,full:options.mask}" >
		<template v-if="loading">
			<div class="mask" v-if="options.mask" @click.stop.prevent="clickMask"></div>
			<div class="loading">
				<div class="loadingIcon" v-if="options.showIcon"></div>
				<div class="loadingText" v-if="options.loadingText">{{options.loadingText}}</div>
			</div>
		</template>
	</div>
</template>

<script setup>
	import {ref,reactive,getCurrentInstance,watch} from "vue";
	let {proxy} = getCurrentInstance();
	const props = defineProps({
	   modelValue:Boolean,
	   value:Boolean,
	   config:Object,
	})
	
	let loading = ref(false),
		options = reactive({
			loadingText:'',
			mask:false,
			showIcon:true,
		});
	watch(()=>props.config,(v)=>{
		Object.assign(options,v);
	},{immediate:true})
	watch([()=>props.modelValue,()=>props.value],(v)=>{
		let _v = v.find(e=>e!=undefined || e!=null);
		loading.value = !!_v;
	},{immediate:true})
	watch(()=>loading.value,(v)=>{
		if(!v){
			Object.assign(options,{
				loadingText:'',
				showIcon:true,
			})
		}
	})
	let show = (opt)=>{
		loading.value = true;
		Object.assign(options,opt??{});
		console.log('options',options)
	}
	let hide = ()=>{
		loading.value = false;
	}
	let clickMask = ()=>{
		// console.log('点击了遮罩');
	}
	
	defineExpose({
		show,hide,
	})
</script>

<style lang="less" scoped>
.loadingBox{
	position:fixed;
	top:0;
	left:0;
	z-index:var(--header-Index);
	&.full{
		right:0;
		bottom:0;
	}
	--backgroundColor:rgba(0, 0, 0, 0.82);
	.mask{
		position:fixed;
		top:0;
		left:0;
		right:0;
		bottom:0;
		z-index: var(--header-Index);
	}
	.loading{
		position:fixed;
		width:50px;
		min-height:50px;
		z-index: 1000;
		left:50%;
		top:50%;
		transform: translate(-50%,-50%);
		background-color: var(--backgroundColor);
		border-radius: 16px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		text-align:center;
		padding: 10px;
		.loadingIcon{
			width: 30px;
			height: 30px;
			border-radius: 50%;
			border:3px solid #ffffff;
			mask:linear-gradient(#0000,#0000),conic-gradient(from 360deg,#ffffff00 0deg, #ffffffc8 ,#fffffff0,white 360deg);
			mask-composite: intersect;
			mask-clip:padding-box,border-box;
			animation: loop 0.8s linear infinite;
		}
		.loadingText{
			text-align:center;
			font-size: 13px;
			padding-top: 30px;
			color:#ffffff;
		}
	}
}
@keyframes loop {
	from {
		transform: rotate(0);
	}
	to {
		transform: rotate(360deg);
	}
}
</style>